import controller from './__init/controller';
import detectTabNav from './__utils/detectTabNav';
import throttle from 'lodash/throttle';

let handled = false;

controller.init();

window.addEventListener('load', controller.loaded);
window.addEventListener('scroll', throttle(controller.scrolled, 100), {
	passive: true,
});
window.addEventListener('resize', throttle(controller.resized, 100));
window.addEventListener('keydown', (e) => {
	detectTabNav(e);
	controller.keyDown(e);
});

const handleMouseAndTouchEvents = (e) => {
	if (e.type === 'touchend') {
		handled = true;
		controller.mouseUp(e);
	} else if (e.type === 'mouseup' && !handled) {
		controller.mouseUp(e);
	} else {
		handled = false;
	}
};

document.addEventListener('DOMContentLoaded', function () {
	// Find all elements where the id starts with "ackgo-"
	const widgetContainers = document.querySelectorAll('[id^="ackgo-"]');

	// If at least one such element exists, load the CSS
	if (widgetContainers.length > 0) {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = 'https://api.ackschedules.com/schedules/css';
		document.head.appendChild(link);
	}

	const bookTripButtons = document.querySelectorAll('a[href="#bookTrip"]');

	if (bookTripButtons) {
		bookTripButtons.forEach((btn) => {
			btn.addEventListener('click', function () {
				const bookingForm = document.querySelector(
					'.inner-page-booking-form'
				);
				if (bookingForm) {
					bookingForm.classList.add('is-expanded');
				}
			});
		});
	}
});

document.addEventListener('mouseup', handleMouseAndTouchEvents);
document.addEventListener('touchend', handleMouseAndTouchEvents);
